// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import {
//     FaGavel,
//     FaShieldAlt,
//     FaChartBar,
//     FaDatabase,
//     FaFileContract,
//     FaUsers,
//     FaCheckCircle,
//     FaExclamationTriangle,
//     FaDownload,
//     FaUpload,
//     FaHistory,
//     FaCog,
//     FaEye,
//     FaEdit,
//     FaTrash,
//     FaSearch,
//     FaFilter,
//     FaCalendarAlt,
//     FaBell
// } from "react-icons/fa";

// // Import tab components
// import FoodPrivacyPolicy from "./FoodPrivacyPolicy";
// import FoodTermsConditions from "./FoodTermsConditions";
// import FoodVendorGuidelines from "./FoodVendorGuidelines";
// import FoodComplianceDashboard from "./FoodComplianceDashboard";
// import FoodDataManagementRequests from "./FoodDataManagementRequests";

// function LegalComplianceHub() {
//     // State for UI
//     const [activeTab, setActiveTab] = useState('legalHub');
//     const [isMobile, setIsMobile] = useState(false);

//     // Check screen size
//     useEffect(() => {
//         const checkMobile = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };

//         checkMobile();
//         window.addEventListener('resize', checkMobile);
//         return () => window.removeEventListener('resize', checkMobile);
//     }, []);

//     // Tabs configuration - Using array for mapping
//     const tabs = [
//         {
//             id: 'legalHub',
//             label: 'Legal & Compliance Hub',
//             icon: <FaGavel />,
//             description: 'Privacy Policy, Terms & Conditions, Vendor Guidelines'
//         },
//         {
//             id: 'dashboard',
//             label: 'Compliance Dashboard',
//             icon: <FaChartBar />,
//             description: 'Monitor compliance metrics and status'
//         },
//         {
//             id: 'dataRequests',
//             label: 'Data Requests',
//             icon: <FaDatabase />,
//             description: 'Manage GDPR and data privacy requests'
//         }
//     ];

//     // Quick Stats
//     const quickStats = [
//         { label: 'Active Policies', value: '12', color: '#3b82f6', icon: <FaFileContract /> },
//         { label: 'Compliance Score', value: '94%', color: '#10b981', icon: <FaCheckCircle /> },
//         { label: 'Pending Reviews', value: '3', color: '#f59e0b', icon: <FaExclamationTriangle /> },
//         { label: 'Open Requests', value: '7', color: '#8b5cf6', icon: <FaUsers /> }
//     ];

//     // Recent Activities
//     const recentActivities = [
//         { id: 1, action: 'Privacy Policy Updated', user: 'Admin User', time: '2 hours ago', status: 'completed' },
//         { id: 2, action: 'GDPR Data Request', user: 'Customer #12345', time: '5 hours ago', status: 'pending' },
//         { id: 3, action: 'Vendor Agreement Signed', user: 'Vendor Corp', time: '1 day ago', status: 'completed' },
//         { id: 4, action: 'Compliance Audit', user: 'Audit Team', time: '2 days ago', status: 'in-progress' }
//     ];

//     // Tab content mapping
//     const tabContent = {
//         'legalHub': (
//             <div style={{ padding: isMobile ? '20px' : '30px' }}>
//                 <div style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '15px',
//                     marginBottom: '30px',
//                     paddingBottom: '20px',
//                     borderBottom: '1px solid #e0e0e0'
//                 }}>
//                     <div style={{
//                         width: '48px',
//                         height: '48px',
//                         borderRadius: '12px',
//                         backgroundColor: '#f5f3ff',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         color: '#6B46C1',
//                         fontSize: '22px'
//                     }}>
//                         <FaGavel />
//                     </div>
//                     <div>
//                         <h2 style={{
//                             margin: '0 0 5px 0',
//                             fontSize: isMobile ? '20px' : '24px',
//                             fontWeight: '600',
//                             color: '#1a1a1a'
//                         }}>
//                             Legal & Compliance Hub
//                         </h2>
//                         <p style={{
//                             margin: 0,
//                             fontSize: isMobile ? '14px' : '16px',
//                             color: '#666'
//                         }}>
//                             Manage Privacy Policy, Terms & Conditions, and Vendor Guidelines
//                         </p>
//                     </div>
//                 </div>

//                 {/* Legal Documents Grid */}
//                 <div className="row" style={{ marginBottom: '30px' }}>
//                     <div className="col-md-4" style={{ marginBottom: '20px' }}>
//                         <FoodPrivacyPolicy isMobile={isMobile} />
//                     </div>
//                     <div className="col-md-4" style={{ marginBottom: '20px' }}>
//                         <FoodTermsConditions isMobile={isMobile} />
//                     </div>
//                     <div className="col-md-4" style={{ marginBottom: '20px' }}>
//                         <FoodVendorGuidelines isMobile={isMobile} />
//                     </div>
//                 </div>
//             </div>
//         ),
//         'dashboard': <FoodComplianceDashboard isMobile={isMobile} />,
//         'dataRequests': <FoodDataManagementRequests isMobile={isMobile} />
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-10 food-pramotions-data-scroll" style={{ height: "80vh", overflowY: "auto", scrollbarWidth: "none" }} >
//                     {/* Breadcrumb */}
//                     <p
//                         className="breadcrumb maamaas-home-bredcum or7"
//                         style={{
//                             position: "fixed",
//                             top: "57px",
//                             left: "1vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             // zIndex: 1000,
//                             padding: "10px 0",
//                             fontSize: "18px",
//                             fontWeight: "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}
//                     >
//                         <Link
//                             to="/Homes"
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Home
//                         </Link>

//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             <Link
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                  Legal & Compliance
//                             </Link>
//                         </span>
//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Food & Beverages
//                         </span>
//                     </p>

//                     <div className="discount-container">
//                         {/* Tab Buttons - FIXED VERSION */}
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 position: "fixed",
//                                 top: "125px",
//                                 left: "55%",
//                                 transform: "translate(-45%, -50%)",
//                                 gap: "0px",
//                                 zIndex: 10,
//                                 width: "100vw",
//                                 maxWidth: "600px",
//                                 flexWrap: "wrap",
//                                 padding: "10px 0",
//                                 backgroundColor: "white",
//                             }}
//                             className="rorr row b2"
//                         >
//                             {tabs.map((tab) => (
//                                 <div
//                                     key={tab.id}
//                                     className="col-lg-4 col-md-6 col-sm-12 col-12"
//                                     style={{
//                                         display: "flex",
//                                         justifyContent: "center",
//                                         marginBottom: "10px",
//                                         minWidth: "150px",
//                                     }}
//                                 >
//                                     <button
//                                         onClick={() => setActiveTab(tab.id)}
//                                         style={{
//                                             border: "none",
//                                             borderRadius: "10px",
//                                             minWidth: "140px",
//                                             width: "100%",
//                                             padding: "0",
//                                             height: "40px",
//                                             backgroundColor: activeTab === tab.id ? "#b15cd6" : "#d9d9d9",
//                                             color: activeTab === tab.id ? "#fff" : "#000",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                             transition: "background-color 0.3s ease",
//                                             fontSize: "0.85rem",
//                                             display: "flex",
//                                             alignItems: "center",
//                                             justifyContent: "center",
//                                             textAlign: "center",
//                                             lineHeight: "1",
//                                         }}
//                                     >
//                                         <span style={{
//                                             display: "inline-block",
//                                             verticalAlign: "middle",
//                                             lineHeight: "normal",
//                                             padding: "0 5px",
//                                             wordWrap: "break-word",
//                                             maxWidth: "100%",
//                                         }}>
//                                             {tab.label}
//                                         </span>
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Tab Content */}
//                         <div
//                             style={{
//                                 height: "95vh",
//                                 overflowY: "auto",
//                                 scrollbarWidth: "none",
//                                 borderRadius: "8px",
//                                 marginTop: "0px",
//                             }}
//                             className="b1"
//                         >
//                             <div style={{
//                                 padding: isMobile ? '20px' : '30px',
//                                 maxWidth: '1200px',
//                                 margin: '0 auto'
//                             }}>
//                                 {/* Header Section */}
//                                 <div className="row" style={{ marginBottom: '30px', paddingTop: '40px' }}>
//                                     <div className="col-md-8">
//                                         <h1 style={{
//                                             fontSize: isMobile ? '24px' : '32px',
//                                             fontWeight: '700',
//                                             color: '#1a1a1a',
//                                             margin: '0 0 10px 0',
//                                             lineHeight: 1.2
//                                         }}>
//                                             Legal & Compliance Management
//                                         </h1>
//                                         <p style={{
//                                             fontSize: isMobile ? '14px' : '16px',
//                                             color: '#666',
//                                             margin: 0,
//                                         }}>
//                                             Manage legal documents, monitor compliance status, and handle data privacy requests
//                                         </p>
//                                     </div>
//                                     <div className="col-md-4" style={{
//                                         display: 'flex',
//                                         gap: '10px',
//                                         justifyContent: 'flex-end',
//                                         flexWrap: 'wrap',
//                                         marginTop: isMobile ? '15px' : '0'
//                                     }}>
//                                         <button
//                                             onClick={() => alert('Exporting all compliance reports...')}
//                                             style={{
//                                                 backgroundColor: 'white',
//                                                 color: '#6B46C1',
//                                                 border: '1px solid #6B46C1',
//                                                 padding: '10px 20px',
//                                                 borderRadius: '8px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '8px',
//                                                 fontSize: '14px',
//                                                 fontWeight: '500',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                             onMouseEnter={(e) => {
//                                                 e.currentTarget.style.backgroundColor = '#6B46C1';
//                                                 e.currentTarget.style.color = 'white';
//                                             }}
//                                             onMouseLeave={(e) => {
//                                                 e.currentTarget.style.backgroundColor = 'white';
//                                                 e.currentTarget.style.color = '#6B46C1';
//                                             }}
//                                         >
//                                             <FaDownload /> Export Reports
//                                         </button>

//                                         <button
//                                             onClick={() => alert('Starting new compliance audit...')}
//                                             style={{
//                                                 backgroundColor: '#6B46C1',
//                                                 color: 'white',
//                                                 border: 'none',
//                                                 padding: '10px 20px',
//                                                 borderRadius: '8px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '8px',
//                                                 fontSize: '14px',
//                                                 fontWeight: '500',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                             onMouseEnter={(e) => {
//                                                 e.currentTarget.style.backgroundColor = '#5a3d9c';
//                                                 e.currentTarget.style.transform = 'translateY(-2px)';
//                                             }}
//                                             onMouseLeave={(e) => {
//                                                 e.currentTarget.style.backgroundColor = '#6B46C1';
//                                                 e.currentTarget.style.transform = 'translateY(0)';
//                                             }}
//                                         >
//                                             <FaCog /> Start Audit
//                                         </button>
//                                     </div>
//                                 </div>

//                                 {/* Quick Stats */}
//                                 <div className="row" style={{ marginBottom: '30px' }}>
//                                     {quickStats.map((stat, index) => (
//                                         <div key={index} className="col-md-3 col-sm-6 col-6" style={{ marginBottom: '15px' }}>
//                                             <div style={{
//                                                 backgroundColor: 'white',
//                                                 padding: '20px',
//                                                 borderRadius: '12px',
//                                                 boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//                                                 border: '1px solid #e5e7eb',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '15px',
//                                                 transition: 'all 0.3s ease',
//                                                 height: '100%'
//                                             }}
//                                                 onMouseEnter={(e) => {
//                                                     e.currentTarget.style.transform = 'translateY(-4px)';
//                                                     e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
//                                                 }}
//                                                 onMouseLeave={(e) => {
//                                                     e.currentTarget.style.transform = 'translateY(0)';
//                                                     e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
//                                                 }}
//                                             >
//                                                 <div style={{
//                                                     width: '48px',
//                                                     height: '48px',
//                                                     borderRadius: '10px',
//                                                     backgroundColor: stat.color + '20',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     color: stat.color,
//                                                     fontSize: '20px'
//                                                 }}>
//                                                     {stat.icon}
//                                                 </div>
//                                                 <div>
//                                                     <div style={{
//                                                         fontSize: '24px',
//                                                         fontWeight: '700',
//                                                         color: '#1a1a1a',
//                                                         marginBottom: '4px'
//                                                     }}>
//                                                         {stat.value}
//                                                     </div>
//                                                     <div style={{
//                                                         fontSize: '14px',
//                                                         color: '#6b7280',
//                                                         fontWeight: '500'
//                                                     }}>
//                                                         {stat.label}
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 {/* Main Content Area */}
//                                 <div className="row">
//                                     {/* Left Column - Main Content */}
//                                     <div className="col-lg-8 col-md-12">
//                                         <div style={{
//                                             backgroundColor: 'white',
//                                             borderRadius: '12px',
//                                             boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//                                             overflow: 'hidden',
//                                             minHeight: '600px',
//                                             marginBottom: '20px'
//                                         }}>
//                                             {tabContent[activeTab]}
//                                         </div>
//                                     </div>

//                                     {/* Right Column - Recent Activities & Quick Actions */}
//                                     <div className="col-lg-4 col-md-12">
//                                         {/* Recent Activities */}
//                                         <div style={{
//                                             backgroundColor: 'white',
//                                             borderRadius: '12px',
//                                             boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//                                             padding: '25px',
//                                             marginBottom: '20px'
//                                         }}>
//                                             <div style={{
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'space-between',
//                                                 marginBottom: '20px'
//                                             }}>
//                                                 <h3 style={{
//                                                     margin: 0,
//                                                     fontSize: '18px',
//                                                     fontWeight: '600',
//                                                     color: '#1a1a1a',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '10px'
//                                                 }}>
//                                                     <FaHistory /> Recent Activities
//                                                 </h3>
//                                                 <button
//                                                     onClick={() => alert('Viewing all activities...')}
//                                                     style={{
//                                                         backgroundColor: 'transparent',
//                                                         color: '#6B46C1',
//                                                         border: 'none',
//                                                         padding: '6px 12px',
//                                                         borderRadius: '6px',
//                                                         cursor: 'pointer',
//                                                         fontSize: '13px',
//                                                         fontWeight: '500'
//                                                     }}
//                                                 >
//                                                     View All
//                                                 </button>
//                                             </div>

//                                             <div style={{
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 gap: '15px'
//                                             }}>
//                                                 {recentActivities.map(activity => (
//                                                     <div key={activity.id} style={{
//                                                         display: 'flex',
//                                                         alignItems: 'flex-start',
//                                                         gap: '12px',
//                                                         padding: '12px',
//                                                         backgroundColor: '#f9fafb',
//                                                         borderRadius: '8px',
//                                                         border: '1px solid #e5e7eb'
//                                                     }}>
//                                                         <div style={{
//                                                             width: '8px',
//                                                             height: '8px',
//                                                             borderRadius: '50%',
//                                                             backgroundColor: activity.status === 'completed' ? '#10b981' :
//                                                                 activity.status === 'pending' ? '#f59e0b' : '#3b82f6',
//                                                             marginTop: '6px',
//                                                             flexShrink: 0
//                                                         }}></div>
//                                                         <div style={{ flex: 1 }}>
//                                                             <div style={{
//                                                                 fontSize: '14px',
//                                                                 fontWeight: '500',
//                                                                 color: '#374151',
//                                                                 marginBottom: '4px'
//                                                             }}>
//                                                                 {activity.action}
//                                                             </div>
//                                                             <div style={{
//                                                                 display: 'flex',
//                                                                 justifyContent: 'space-between',
//                                                                 alignItems: 'center'
//                                                             }}>
//                                                                 <span style={{
//                                                                     fontSize: '12px',
//                                                                     color: '#6b7280'
//                                                                 }}>
//                                                                     {activity.user}
//                                                                 </span>
//                                                                 <span style={{
//                                                                     fontSize: '12px',
//                                                                     color: '#9ca3af'
//                                                                 }}>
//                                                                     {activity.time}
//                                                                 </span>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Footer Note */}
//                                 <div className="row" style={{ marginTop: '30px' }}>
//                                     <div className="col-12">
//                                         <div style={{
//                                             padding: '20px',
//                                             backgroundColor: '#f9fafb',
//                                             borderRadius: '12px',
//                                             textAlign: 'center',
//                                             border: '1px solid #e5e7eb'
//                                         }}>
//                                             <p style={{
//                                                 margin: '0',
//                                                 fontSize: isMobile ? '13px' : '14px',
//                                                 color: '#6b7280',
//                                                 lineHeight: 1.6
//                                             }}>
//                                                 <FaShieldAlt style={{ marginRight: '8px', color: '#9ca3af' }} />
//                                                 All legal documents and compliance activities are logged and timestamped for audit purposes.
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default LegalComplianceHub;















import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FoodPrivacyPolicy from "./FoodPrivacyPolicy";
import FoodTermsConditions from "./FoodTermsConditions";
import FoodVendorGuidelines from "./FoodVendorGuidelines";
import FoodComplianceStatus from "./FoodComplianceStatus";
import "./FoodLeaguelCompliance.css";

function FoodLeaguelCompliance() {
    const [activeTab, setActiveTab] = useState('privacy');
    const [isMobile, setIsMobile] = useState(false);
    const [termsTabJustOpened, setTermsTabJustOpened] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
            setWindowWidth(window.innerWidth);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Tabs configuration
    const tabs = [
        { id: 'privacy', label: 'Privacy Policy', icon: '🔒' },
        { id: 'terms', label: 'Terms & Conditions', icon: '📜' },
        { id: 'guidelines', label: 'Admin Guidelines', icon: '🍽️' },
        { id: 'compliance', label: 'Compliance Status', icon: '📊' }
    ];

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);

        if (tabId === 'terms') {
            setTermsTabJustOpened(true);
        } else {
            setTermsTabJustOpened(false);
        }

        // Smooth scroll to top on mobile
        if (isMobile) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Get current page name based on active tab
    const getCurrentPageName = () => {
        switch (activeTab) {
            case 'privacy': return 'Privacy Policy';
            case 'terms': return 'Terms & Conditions';
            case 'guidelines': return 'Vendor Guidelines';
            case 'compliance': return 'Compliance Status';
            default: return 'Privacy Policy';
        }
    };

    // Render the active tab component
    const renderActiveTab = () => {
        switch (activeTab) {
            case 'privacy':
                return <FoodPrivacyPolicy isMobile={isMobile} />;
            case 'terms':
                return <FoodTermsConditions isMobile={isMobile} autoAgree={termsTabJustOpened} />;
            case 'guidelines':
                return <FoodVendorGuidelines isMobile={isMobile} />;
            case 'compliance':
                return <FoodComplianceStatus isMobile={isMobile} />;
            default:
                return <FoodPrivacyPolicy isMobile={isMobile} />;
        }
    };

    return (
        <div
            style={{
                maxWidth: '1124px',
                margin: '107px auto',
                padding: isMobile ? '10px' : '20px',
                height: "75vh",
                width: "90vw",
                scrollbarWidth: "none",
                overflow: 'auto',
                fontFamily: 'Arial, sans-serif',
                overflowX: 'hidden',
                boxSizing: 'border-box',
            }}
        >

            {/* Fixed Breadcrumb */}
            <div
                style={{
                    position: "fixed",
                    top: windowWidth <= 425 ? "60px" : windowWidth > 425 && windowWidth <= 768 ? "64px" : "75px",
                    left: "0",
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    padding: "10px 0",
                    fontSize: isMobile ? "16px" : "18px",
                    fontWeight: isMobile ? "normal" : "bold",
                    textAlign: "center",
                    margin: 0,
                    //borderBottom: "1px solid #eee",
                    //boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
            >
                <p
                    className="breadcrumb maamaas-home-bredcum or22"
                    style={{
                        position: "fixed",
                        top: "57px",
                        left: "1vw",
                        width: "100%",
                        backgroundColor: "#fff",
                        // zIndex: 1000,
                        padding: "10px 0",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textAlign: "center",
                        margin: 0,
                    }}
                >
                    <Link
                        to="/Homes"
                        style={{
                            color: "purple",
                            fontWeight: "bold",
                            textDecoration: "none",
                        }}
                    >
                        Home
                    </Link>

                    <span className="separator"> &gt; </span>
                    <span
                        style={{
                            color: "purple",
                            fontWeight: "bold",
                            textDecoration: "none",
                        }}
                    >
                        <Link
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                             Legal & Compliance
                        </Link>
                    </span>
                    <span className="separator"> &gt; </span>
                    <span
                        style={{
                            color: "purple",
                            fontWeight: "bold",
                            textDecoration: "none",
                        }}
                    >
                        Food & Beverages
                    </span>
                </p>
            </div>

            {/* Main content - added padding-top to account for fixed breadcrumb */}
            <div style={{ paddingTop: "0px" }}>
                {/* Tabs */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: isMobile ? '5px' : '10px',
                    marginBottom: '20px',
                    backgroundColor: 'white',
                    padding: isMobile ? '8px' : '10px',
                    borderRadius: '10px',
                    overflowX: isMobile ? 'auto' : 'visible',
                    WebkitOverflowScrolling: 'touch',
                    scrollbarWidth: 'none',
                    // marginTop: "-30px",
                    msOverflowStyle: 'none'
                }}className="legal-res" >
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => handleTabChange(tab.id)}
                            style={{
                                padding: isMobile ? '8px 12px' : '12px 20px',
                                border: 'none',
                                backgroundColor: activeTab === tab.id ? '#A055B0' : '#f5f5f5',
                                color: activeTab === tab.id ? 'white' : '#333',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: isMobile ? '6px' : '8px',
                                fontSize: isMobile ? '12px' : '14px',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                flexShrink: 0,
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {tab.icon} {tab.label}
                        </button>
                    ))}
                </div>

                {/* Tab Content */}
                <div style={{
                    minHeight: '500px',
                    overflow: 'visible'
                }}>
                    {renderActiveTab()}
                </div>
            </div>
        </div>
    );
}

export default FoodLeaguelCompliance;